import { I18nUtils } from '../../../../i18n/I18nUtils';
import { isDNIValid } from '../../../shared/utils/StringUtils';

export class WorkerFormValidator {

    static validate(values) {
        const {
            dni,
            name,
            lastName,
            agreement,
            contractorSchemas,
        } = values;

        let errors = {};
        const emptyFieldError = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');

        if ( !dni ) errors.dni = emptyFieldError;
        if ( !name ) errors.name = emptyFieldError;
        if ( !lastName ) errors.lastName = emptyFieldError;
        if ( !agreement ) errors.agreement = emptyFieldError;

        if ( dni && !isDNIValid(dni) ) errors.dni = I18nUtils.tr('TR_DNI_NO_VALIDO');

        if ( contractorSchemas && contractorSchemas.length !== 0 ) {
            const errorsContractorSchemas = [];
            contractorSchemas.forEach((contractorSchema, indexContractorSchema) => {
                errorsContractorSchemas.push({});
                if ( contractorSchema.position && ( !contractorSchema.schema || contractorSchema.schema.length === 0 ) ) {
                    errorsContractorSchemas[indexContractorSchema]['schema'] = emptyFieldError;
                }
            });

            errors.contractorSchemas = errorsContractorSchemas;
        }

        return errors;
    };
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/form/WorkerFormValidator.js